export default __webpack_public_path__ + "static/media/notification.c6a60fad.svg";